import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const FundBasedLendingInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section fund-based-lending-fin">
                <h2 className="other-pages-title">Fund-Based Lending</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/fund-based-lending-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Fund-Based Lending</span>
                </p>
            </div>

            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Fund-Based Lending?</h2>

                <p className="info-loan-description-smco">
                    Fund-based lending refers to credit facilities where actual funds are disbursed to the borrower for various business needs. These include Cash Credit (CC), Overdraft (OD) limits, Term Loans, and Project Financing. Unlike non-fund based lending, these facilities involve the transfer of money, providing immediate liquidity for operational and capital expenditures.
                    <br /><br />
                    Fund-based lending is essential for businesses requiring substantial capital for expansion, working capital, or long-term investments. KRS FinSolutions specializes in facilitating these lending solutions, connecting businesses with banks and financial institutions to secure the necessary funding at competitive terms.
                    <br /><br />
                    Our expertise spans various fund-based products, ensuring that each client's unique financial requirements are met with tailored solutions that support sustainable growth and operational efficiency.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Fund-Based Lending</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Cash Credit (CC):</strong> Revolving credit facility secured against inventory or receivables, providing flexible access to funds up to a sanctioned limit.</li>
                        <li><strong>Overdraft (OD) Limits:</strong> Allows businesses to withdraw more than their account balance, ideal for managing short-term cash flow fluctuations.</li>
                        <li><strong>Term Loans:</strong> Fixed-amount loans with predetermined repayment schedules, suitable for long-term investments like equipment purchase or business expansion.</li>
                        <li><strong>Project Financing:</strong> Specialized funding for large-scale projects, often involving multiple lenders and structured repayment based on project cash flows.</li>
                        <li><strong>Working Capital Loans:</strong> Short-term loans to cover day-to-day operational expenses, inventory, and payroll.</li>
                        <li><strong>Equipment Financing:</strong> Loans specifically for purchasing machinery, vehicles, or technology to enhance business operations.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Flexible repayment:</strong> Options ranging from bullet payments to monthly EMIs based on cash flow patterns.</li>
                        <li><strong>Competitive rates:</strong> Interest rates tailored to business profile, creditworthiness, and market conditions.</li>
                        <li><strong>Scalable limits:</strong> Credit facilities that can be increased as business grows.</li>
                        <li><strong>Quick disbursal:</strong> Fast approval and funding once documentation is complete.</li>
                        <li><strong>Collateral options:</strong> Secured and unsecured options available based on lender requirements.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Fund-Based Lending</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Immediate liquidity:</strong> Direct access to funds for urgent business needs and opportunities.</li>
                        <li><strong>Business growth:</strong> Capital for expansion, new market entry, and operational scaling.</li>
                        <li><strong>Cash flow management:</strong> Better management of receivables, payables, and working capital cycles.</li>
                        <li><strong>Tax benefits:</strong> Interest payments may be tax-deductible, reducing overall borrowing costs.</li>
                        <li><strong>Relationship building:</strong> Establishes long-term banking relationships for future financial needs.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Our Fund-Based Lending Services</h3>
                    <p>
                        KRS FinSolutions provides end-to-end support for fund-based lending requirements:
                        <br />• <strong>Needs assessment:</strong> Comprehensive evaluation of your funding requirements and business financials.
                        <br />• <strong>Lender matching:</strong> Identification of suitable banks and NBFCs based on your industry and risk profile.
                        <br />• <strong>Application assistance:</strong> Guidance through the application process, documentation, and compliance requirements.
                        <br />• <strong>Negotiation:</strong> Securing optimal terms, rates, and covenants from multiple lender options.
                        <br />• <strong>Disbursement coordination:</strong> Ensuring timely fund transfer and utilization monitoring.
                        <br />• <strong>Ongoing support:</strong> Regular follow-ups, renewal assistance, and relationship management with lenders.
                    </p>
                </div>
            </div>

            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default FundBasedLendingInfo;
